// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";

// HELPERS
import {createClassName} from "@helpers/utils";
import fulfillmentCheck from "./IskBilagor.fulfillment";
import CheckboxWithName from "../../components/CheckboxWithName/CheckboxWithName";
import imgPdf from "@assets/img/ic_pdf.png";


export default class IskBilagor extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {
		const {state} = this;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div style={{alignItems: "flex-start", width: "100%"}}>
					<h2>Bilagor</h2>

					<div style={{display: "block"}}>
						<p style={{margin: "0 0 10px 0"}}>
							<a href="https://assets.fairinvestments.se/allmanna-bestammelser-depa-1-5.pdf" rel="noopener noreferrer"
							   target="_blank" style={{
								display: "flex",
								alignItems: "center"
							}}>
								<img src={imgPdf} style={{height: "30px", marginRight: "10px"}} alt="Ladda ner"/>
								Allmänna bestämmelser för depå
							</a>
						</p>

						<p style={{margin: "10px 0 20px 0"}}>
							<a href="https://assets.fairinvestments.se/allmanna-villkor-isk-210504.pdf" rel="noopener noreferrer"
							   target="_blank" style={{
								display: "flex",
								alignItems: "center"
							}}>
								<img src={imgPdf} style={{height: "30px", marginRight: "10px"}} alt="Ladda ner"/>
								Allmänna villkor för Investeringssparkonto
							</a>
						</p>
					</div>

					<FieldsCollection
						fields={[
							{
								render: (
									<CheckboxWithName
										label="Jag har tagit del av och godkänt 'Allmänna bestämmelser för depå'"
										name="checkbox_customer_kyc_forkop"
										value={state.fields.checkbox_customer_kyc_forkop.checked ? "yes" : "no"}
										checked={state.fields.checkbox_customer_kyc_forkop.checked}
										onChange={this._onCheckboxChange}
									/>
								),
							},
							{
								render: (
									<CheckboxWithName
										label="Jag har tagit del av och godkänt 'Allmänna villkor för Investeringssparkonto'"
										name="checkbox_customer_kyc_isk"
										value={state.fields.checkbox_customer_kyc_isk.checked ? "yes" : "no"}
										checked={state.fields.checkbox_customer_kyc_isk.checked}
										onChange={this._onCheckboxChange}
									/>
								),
							},
						]}
					/>
				</div>
			</div>
		);
	}

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};
}


// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"checkbox_customer_kyc_forkop",
		"checkbox_customer_kyc_isk"
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};
	return {
		validFields: [],
		fields: {
			"checkbox_customer_kyc_forkop": {
				checked: false
			},
			"checkbox_customer_kyc_isk": {
				checked: false
			}
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/IskBilagor.js